// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1ao_c","author":"Table_author__1m_xt","authorImage":"Table_authorImage__2MVfQ","unreadRow":"Table_unreadRow__3GN6n"};